import { jsx as _jsx } from "react/jsx-runtime";
import { edgeTypeMatrix } from '@iotv/datamodel';
import { TreeItem2 as TreeItem } from '@mui/x-tree-view';
import { ObjectTree } from '../../../../v2/components/generic/ObjectTree';
import { ContextMenu } from '../../ContextMenuV2/ContextMenu';
import { CustFolderClickWrapper } from '../../clickWrappers/helpers';
import { customerOnDemandProgrammesTreeDef } from '../OnDemandProgrammes';
export const OnDemandProgrammes = ({ applicationData, contextCustomer, transactionFunctions, userFunctions, user, roleArbitrationInstance }) => {
    const ondemandProgrammesLabel = contextCustomer && (_jsx(ContextMenu, { label: "On Demand Programmes", hideDelete: true, popUpElement: null, contextObject: contextCustomer, edgeTypeIdFilter: [edgeTypeMatrix.Customer.OnDemandProgramme.customer_has_on_demand_programme.edgeTypeId], defaultCreationProperties: {
            startTime: 0,
        }, ascendentAccessor: { ascendentAccessor: null, contextObject: contextCustomer } }));
    return (contextCustomer && (_jsx(TreeItem, { itemId: "OnDemandProgrammes", label: ondemandProgrammesLabel, children: _jsx(ObjectTree, { nodeEdgeMapper: applicationData,
            queryPaths: [customerOnDemandProgrammesTreeDef],
            contextObjects: [contextCustomer],
            transactionFunctions,
            onTypeFolderClickWrapper: CustFolderClickWrapper,
            hideTopStep: true }, `customerOnDemandProgrammes`) }, 'OnDemandProgrammes')));
};
